<script setup lang="ts">
import HeroFull from '@storefront-satch/components/molecules/hero/HeroFull.vue'
import HeroFullLow from '@storefront-satch/components/molecules/hero/HeroFullLow.vue'
import HeroHalf from '@storefront-satch/components/molecules/hero/HeroHalf.vue'
import HeroHalfLow from '@storefront-satch/components/molecules/hero/HeroHalfLow.vue'
import type { BrandHero } from '@storefront-satch/components/molecules/hero/types'

const props = defineProps<BrandHero>()
</script>
<template>
  <HeroFull
    v-if="props.type === 'full'"
    v-bind="props"
  />
  <HeroFullLow
    v-if="props.type === 'full low'"
    v-bind="props"
  />
  <HeroHalf
    v-if="props.type === 'half'"
    v-bind="props"
  />
  <HeroHalfLow
    v-if="props.type === 'half low'"
    v-bind="props"
  />
</template>
